import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import _isNumber from "lodash/isNumber";

var _templateObject;

import React, { useContext } from 'react';
import classNames from 'classnames';
import { gql } from '@nerdwallet/apollo';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import MarketplaceCta from '@nerdwallet/react-marketplace-cta';
import { DisclaimerAd } from '@nerdwallet/react-disclaimer-ad';
import MarketplaceApplyNow, { APPLY_NOW_LINK_TYPES, LINK_TYPES } from '@nerdwallet/react-marketplace-apply-now';
import MarketplaceStarRating, { LAYOUTS, GraphQlMarketplaceStarRating } from '@nerdwallet/react-marketplace-star-rating';
import { TrkElement } from '@nerdwallet/nw-client-lib/trk-helper';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { getMatchScore } from '@nerdwallet/marketplace/selectors/credit-cards';
import { TRK_PRODUCT_LOCATION } from '../lib/constants';
import { buildTrkSectionCategory } from '../lib/utils';
import styles from './keto-product-card.module.less';
import MatchScoreCTA, { GraphqlMatchScoreCTA } from '../match-score-cta/match-score-cta';
export var GraphQLKetoImageAndRating = function GraphQLKetoImageAndRating(_ref) {
  var analytics = _ref.analytics,
      approvalLikelihood = _ref.approvalLikelihood,
      className = _ref.className,
      disableAnnotation = _ref.disableAnnotation,
      id = _ref.id,
      identity = _ref.identity,
      imageDataSource = _ref.imageDataSource,
      increaseCardImageSize = _ref.increaseCardImageSize,
      marketplaceEntity = _ref.marketplaceEntity,
      legacyTrkProps = _ref.legacyTrkProps,
      productCardImage = _ref.productCardImage,
      reviewLinkOverride = _ref.reviewLinkOverride,
      secondaryCtas = _ref.secondaryCtas,
      shouldOmitCta = _ref.shouldOmitCta,
      shouldOmitRating = _ref.shouldOmitRating,
      showMatchScoreCTA = _ref.showMatchScoreCTA,
      showNotYetRated = _ref.showNotYetRated,
      riaDisclaimerDetails = _ref.riaDisclaimerDetails,
      shouldHighlightDrivers = _ref.shouldHighlightDrivers,
      riaReviewDateInfo = _ref.riaReviewDateInfo;

  /*
   * @todo https://nerdwallet.atlassian.net/browse/RUR-532 to get the actual matchScore
   * Leaving this for now because the field will be defined in the styleguide but will be undefined
   * for the client.
   */
  var matchScore = marketplaceEntity.matchScore;

  var _ref2 = legacyTrkProps !== null && legacyTrkProps !== void 0 ? legacyTrkProps : {},
      trkPageType = _ref2.trkPageType,
      trkProductPosition = _ref2.trkProductPosition,
      trkSectionCategory = _ref2.trkSectionCategory,
      taxonomy = _ref2.trkTaxonomy;

  var marketplaceStarRating = showNotYetRated ? /*#__PURE__*/React.createElement(GraphQlMarketplaceStarRating, {
    analytics: analytics,
    className: "".concat(styles.starRatingContainer, " ").concat(styles.noStarRatingWidth),
    marketplaceEntity: {},
    showNotYetRated: true,
    trkLocation: TRK_PRODUCT_LOCATION,
    trkPageType: trkPageType,
    riaReviewDateInfo: riaReviewDateInfo
  }) : /*#__PURE__*/React.createElement(GraphQlMarketplaceStarRating, {
    analytics: analytics,
    className: shouldHighlightDrivers ? styles.starRatingContainerInline : styles.starRatingContainer,
    shouldDisplayInline: increaseCardImageSize,
    layout: shouldHighlightDrivers ? LAYOUTS.SMALL_NUMERIC_INLINE : LAYOUTS.NUMERIC,
    marketplaceEntity: marketplaceEntity,
    omitRatingNumberHref: false,
    omitRatingTextHref: true,
    ratingTextHref: reviewLinkOverride,
    smallRatingText: true,
    trkLocation: TRK_PRODUCT_LOCATION // legacy tracking
    ,
    trkPageType: trkPageType // legacy tracking
    ,
    trkTaxonomy: taxonomy // legacy tracking
    ,
    riaReviewDateInfo: riaReviewDateInfo
  });
  var productImageSection = /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.imageWrapper, styles.productImage])
  }, imageDataSource ? shouldOmitCta ? productCardImage : /*#__PURE__*/React.createElement(MarketplaceCta, {
    analyticsPayloadOverrides: {
      element_position: trkProductPosition
    },
    id: "".concat(TRK_PRODUCT_LOCATION, "__product-image--").concat(trkProductPosition),
    gqlMarketplaceEntity: marketplaceEntity,
    legacyTrkProps: {
      trkElement: TrkElement.image,
      trkPageType: trkPageType,
      trkSectionCategory: buildTrkSectionCategory(trkSectionCategory, 'productImage'),
      trkTaxonomy: taxonomy
    },
    linkType: APPLY_NOW_LINK_TYPES.productImage,
    omitImpression: true,
    reviewLinkOverride: reviewLinkOverride
  }, productCardImage) : null);
  var starRatingSection = /*#__PURE__*/React.createElement("div", {
    className: styles.starRating
  }, showMatchScoreCTA && _isNumber(matchScore) ? /*#__PURE__*/React.createElement(GraphqlMatchScoreCTA, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.matchScoreCTAProps,
    approvalLikelihood: approvalLikelihood,
    identity: identity,
    isKetoCard: true,
    marketplaceEntity: marketplaceEntity,
    taxonomy: taxonomy
  }) : !shouldOmitRating ? marketplaceStarRating : null, /*#__PURE__*/React.createElement("div", null, !shouldHighlightDrivers && secondaryCtas));
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([increaseCardImageSize ? styles.enlargedProductImageLayout : '', styles.ketoImageAndRatingWrapper])
  }, increaseCardImageSize ? [productImageSection, starRatingSection] : [starRatingSection, productImageSection], !shouldHighlightDrivers && /*#__PURE__*/React.createElement("div", {
    className: styles.applyNow
  }, /*#__PURE__*/React.createElement(MarketplaceCta, {
    analyticsPayloadOverrides: {
      element_position: trkProductPosition
    },
    className: styles.productLink,
    disableAnnotation: disableAnnotation,
    gqlMarketplaceEntity: marketplaceEntity,
    id: id,
    legacyTrkProps: {
      trkPageType: trkPageType,
      trkSectionCategory: buildTrkSectionCategory(trkSectionCategory, 'cta'),
      trkTaxonomy: taxonomy
    },
    linkType: APPLY_NOW_LINK_TYPES.applyNowButton,
    omitImpression: true,
    reviewLinkOverride: reviewLinkOverride
  }))), !!(riaDisclaimerDetails !== null && riaDisclaimerDetails !== void 0 && riaDisclaimerDetails.text) && /*#__PURE__*/React.createElement("div", {
    className: riaDisclaimerDetails !== null && riaDisclaimerDetails !== void 0 && riaDisclaimerDetails.isFidelity ? classNames([styles.riaFidelityDisclaimerContainer]) : classNames([styles.riaDisclaimerContainer])
  }, /*#__PURE__*/React.createElement(DisclaimerAd, {
    renderAd: riaDisclaimerDetails === null || riaDisclaimerDetails === void 0 ? void 0 : riaDisclaimerDetails.renderAd,
    text: riaDisclaimerDetails === null || riaDisclaimerDetails === void 0 ? void 0 : riaDisclaimerDetails.text,
    tooltipContent: riaDisclaimerDetails === null || riaDisclaimerDetails === void 0 ? void 0 : riaDisclaimerDetails.tooltipContent
  })));
};
GraphQLKetoImageAndRating.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment GraphQLKetoImageAndRating on MarketplaceEntityInterface {\n    ...MarketplaceStarRating\n    ...GraphqlMatchScoreCTA\n  }\n  ", "\n  ", "\n"])), GraphQlMarketplaceStarRating.fragment, GraphqlMatchScoreCTA.fragment);

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  GraphQLKetoImageAndRating.propTypes = {
    analytics: PropTypes.shape({
      entityName: PropTypes.string,
      matchScoreCTAProps: PropTypes.object // eslint-disable-line react/forbid-prop-types

    }),
    approvalLikelihood: PropTypes.number,
    className: PropTypes.string,
    disableAnnotation: PropTypes.bool,
    id: PropTypes.string,
    identity: PropTypes.oneOfType([PropTypes.shape({
      vantageScore3: PropTypes.number
    }), PropTypes.shape({
      profiles: PropTypes.shape({
        tu_credit_report_profile: PropTypes.shape({
          vantage_score_3: PropTypes.number
        })
      })
    })]),
    imageDataSource: PropTypes.string,
    increaseCardImageSize: PropTypes.bool,
    legacyTrkProps: PropTypes.shape({
      trkPageType: PropTypes.string,
      trkProductPosition: PropTypes.number,
      trkSectionCategory: PropTypes.string,
      trkTaxonomy: PropTypes.shape({
        /** Taxonomy page type. */
        pageType: PropTypes.string,

        /** Taxonomy topic. */
        topic: PropTypes.string,

        /** Taxonomy vertical. */
        vertical: PropTypes.string
      })
    }),
    marketplaceEntity: PropTypes.shape({
      matchScore: PropTypes.number,
      reviewLink: PropTypes.string
    }),
    productCardImage: PropTypes.node,
    reviewLinkOverride: PropTypes.string,
    secondaryCtas: PropTypes.node,
    shouldOmitCta: PropTypes.bool,
    shouldOmitRating: PropTypes.bool,
    showMatchScoreCTA: PropTypes.bool,
    showNotYetRated: PropTypes.bool,
    shouldHighlightDrivers: PropTypes.bool,
    riaReviewDateInfo: PropTypes.shape({
      reviewedAtDate: PropTypes.string,
      periodConsideredDate: PropTypes.string
    })
  };
}

var KetoImageAndRating = function KetoImageAndRating(_ref3) {
  var analytics = _ref3.analytics,
      className = _ref3.className,
      ctaHref = _ref3.ctaHref,
      ctaSubtext = _ref3.ctaSubtext,
      ctaShowIcon = _ref3.ctaShowIcon,
      ctaText = _ref3.ctaText,
      displayPage = _ref3.displayPage,
      enableAnalytics = _ref3.enableAnalytics,
      imageData = _ref3.imageData,
      id = _ref3.id,
      identity = _ref3.identity,
      secondaryCtas = _ref3.secondaryCtas,
      marketplaceEntity = _ref3.marketplaceEntity,
      omitCta = _ref3.omitCta,
      omitRating = _ref3.omitRating,
      productType = _ref3.productType,
      reviewLinkHref = _ref3.reviewLinkHref,
      shouldLogImpression = _ref3.shouldLogImpression,
      starRating = _ref3.starRating,
      taxonomy = _ref3.taxonomy,
      trkPageType = _ref3.trkPageType,
      trkProductPosition = _ref3.trkProductPosition,
      trkSectionCategory = _ref3.trkSectionCategory,
      productCardImage = _ref3.productCardImage,
      showNotYetRated = _ref3.showNotYetRated,
      showMatchScoreCTA = _ref3.showMatchScoreCTA;
  var impressionContext = useContext(ImpressionContext);
  useDeprecatedPropsWarning({
    component: 'KetoImageAndRating',
    deprecatedProps: [{
      component: 'KetoImageAndRating',
      deprecatedProps: [{
        version: '6.9.0',
        deprecated: 'enableAnalytics',
        migration: 'Use analytics instead.'
      }]
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });
  var marketplaceStarRating = showNotYetRated ? /*#__PURE__*/React.createElement(MarketplaceStarRating, {
    analytics: analytics,
    enableAnalytics: enableAnalytics || !_isEmpty(analytics),
    marketplaceEntity: {},
    showNotYetRated: true,
    trkLocation: TRK_PRODUCT_LOCATION,
    trkPageType: trkPageType,
    className: "".concat(styles.starRatingContainer, " ").concat(styles.noStarRatingWidth)
  }) : /*#__PURE__*/React.createElement(MarketplaceStarRating, {
    analytics: analytics,
    enableAnalytics: enableAnalytics || !_isEmpty(analytics),
    marketplaceEntity: marketplaceEntity,
    layout: LAYOUTS.NUMERIC,
    omitRatingNumberHref: false,
    omitRatingTextHref: true,
    smallRatingText: true,
    className: styles.starRatingContainer,
    productType: productType,
    ratingTextHref: reviewLinkHref,
    starRating: starRating,
    trkLocation: TRK_PRODUCT_LOCATION // TODO stop passing this through
    ,
    trkPageType: trkPageType,
    trkTaxonomy: taxonomy
  });
  var matchScore = getMatchScore(marketplaceEntity);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.ketoImageAndRatingWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.starRating
  }, showMatchScoreCTA && matchScore ? /*#__PURE__*/React.createElement(MatchScoreCTA, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.matchScoreCTAProps,
    identity: identity,
    isKetoCard: true,
    marketplaceEntity: marketplaceEntity,
    taxonomy: taxonomy
  }) : !omitRating && marketplaceStarRating, /*#__PURE__*/React.createElement("div", null, secondaryCtas)), /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.imageWrapper, styles.productImage])
  }, _get(imageData, 'src') ? omitCta ? productCardImage : /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
    id: "".concat(TRK_PRODUCT_LOCATION, "__product-image--").concat(trkProductPosition),
    impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
    link: ctaHref,
    linkType: APPLY_NOW_LINK_TYPES.productImage,
    marketplaceEntity: marketplaceEntity,
    productLocation: TRK_PRODUCT_LOCATION,
    productPosition: trkProductPosition,
    reviewLink: reviewLinkHref,
    shouldLogImpression: shouldLogImpression,
    trkElement: TrkElement.image,
    trkPageType: trkPageType,
    trkSectionCategory: buildTrkSectionCategory(trkSectionCategory, 'productImage'),
    trkTaxonomy: taxonomy,
    type: LINK_TYPES.LINK // BNK specific props
    ,
    displayPage: displayPage,
    disableBankCtaAnnotation: true
  }, productCardImage) : null), /*#__PURE__*/React.createElement("div", {
    className: styles.applyNow
  }, /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
    annotationText: ctaSubtext,
    className: styles.productLink,
    disableAnnotation: ctaSubtext === false,
    id: id,
    impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
    link: ctaHref,
    linkType: APPLY_NOW_LINK_TYPES.applyNowButton,
    marketplaceEntity: marketplaceEntity,
    productLocation: TRK_PRODUCT_LOCATION // TODO stop passing this through
    ,
    productPosition: trkProductPosition,
    reviewLink: reviewLinkHref,
    shouldLogImpression: shouldLogImpression,
    showIcon: ctaShowIcon,
    text: ctaText,
    trkPageType: trkPageType,
    trkSectionCategory: buildTrkSectionCategory(trkSectionCategory, 'cta'),
    trkTaxonomy: taxonomy,
    type: LINK_TYPES.BUTTON // BNK specific props.
    ,
    displayPage: displayPage
  }))));
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes = require('prop-types');

  KetoImageAndRating.propTypes = {
    className: _PropTypes.string,
    ctaHref: _PropTypes.string,
    ctaSubtext: _PropTypes.string,
    ctaShowIcon: _PropTypes.bool,
    ctaText: _PropTypes.string,
    imageData: _PropTypes.object,
    // eslint-disable-line react/forbid-prop-types
    id: _PropTypes.string,
    secondaryCtas: _PropTypes.node,
    marketplaceEntity: _PropTypes.object.isRequired,
    // eslint-disable-line react/forbid-prop-types
    omitCta: _PropTypes.bool,
    omitRating: _PropTypes.bool,
    productType: _PropTypes.string,
    reviewLinkHref: _PropTypes.string,
    shouldLogImpression: _PropTypes.bool,
    starRating: _PropTypes.number,
    taxonomy: _PropTypes.object,
    // eslint-disable-line react/forbid-prop-types
    trkPageType: _PropTypes.string,
    trkProductPosition: _PropTypes.number,
    trkSectionCategory: _PropTypes.string,
    productCardImage: _PropTypes.node,
    showNotYetRated: _PropTypes.bool,
    // BNK specific props.
    displayPage: _PropTypes.string,
    // analytics
    analytics: _PropTypes.shape({
      entityName: _PropTypes.string,
      matchScoreCTAProps: _PropTypes.object // eslint-disable-line react/forbid-prop-types

    }),

    /** @deprecated A flag to indicate if to send analytics */
    enableAnalytics: _PropTypes.bool,
    // cc specific props
    identity: _PropTypes.object,
    // eslint-disable-line react/forbid-prop-types
    showMatchScoreCTA: _PropTypes.bool,
    riaDisclaimerDetails: _PropTypes.shape({
      renderAd: _PropTypes.boolean,
      text: _PropTypes.string,
      isFidelity: _PropTypes.bool
    })
  };
}

KetoImageAndRating.defaultProps = {
  analytics: {},
  omitRating: false,
  displayPage: '',
  // CC specific props
  identity: {},
  showMatchScoreCTA: false,
  riaDisclaimerDetails: {
    renderAd: false,
    text: undefined,
    isFidelity: false
  }
};
export default KetoImageAndRating;